module.exports = __webpack_public_path__ + "static/img/bg_theme_brown@2x.46f12a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/skin/bg_theme_brown@2x.png
// module id = ZNbx
// module chunks = 1